/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Build_Grounding_TitleInputs */

const en_us2_plan_build_grounding_title = /** @type {(inputs: Plan_Build_Grounding_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 answer left for your trainer to know you better`);
	return /** @type {LocalizedString} */ (`${i?.count} answers left for your trainer to know you better`)
	
};

const pt_br2_plan_build_grounding_title = /** @type {(inputs: Plan_Build_Grounding_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 resposta para o personal te conhecer melhor`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.count} respostas para o personal te conhecer melhor`)
	
};

const es_419_plan_build_grounding_title = /** @type {(inputs: Plan_Build_Grounding_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 respuesta para que tu entrenador te conozca mejor`);
	return /** @type {LocalizedString} */ (`Faltan ${i?.count} respuestas para que tu entrenador te conozca mejor`)
	
};

const pt_pt2_plan_build_grounding_title = /** @type {(inputs: Plan_Build_Grounding_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Falta 1 resposta para o treinador te conhecer melhor`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.count} respostas para o treinador te conhecer melhor`)
	
};

const fr_fr2_plan_build_grounding_title = /** @type {(inputs: Plan_Build_Grounding_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Plus qu'1 réponse pour que ton coach te connaisse mieux`);
	return /** @type {LocalizedString} */ (`Plus que ${i?.count} réponses pour que ton coach te connaisse mieux`)
	
};

const de_de2_plan_build_grounding_title = /** @type {(inputs: Plan_Build_Grounding_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Noch 1 Antwort, damit dein Coach dich besser kennt`);
	return /** @type {LocalizedString} */ (`Noch ${i?.count} Antworten, damit dein Coach dich besser kennt`)
	
};

const it_it2_plan_build_grounding_title = /** @type {(inputs: Plan_Build_Grounding_TitleInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`Manca 1 risposta perché il coach ti conosca meglio`);
	return /** @type {LocalizedString} */ (`Mancano ${i?.count} risposte perché il coach ti conosca meglio`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 answer left for your trainer to know you better" |
* | * | "{count} answers left for your trainer to know you better" |
*
* @param {Plan_Build_Grounding_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_title = /** @type {((inputs: Plan_Build_Grounding_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_title(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_title(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_title(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_title(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_title(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_title(inputs)
	return en_us2_plan_build_grounding_title(inputs)
});
export { plan_build_grounding_title as "plan-build.grounding_title" }